import { AxiosInstance } from 'axios'
import { apiEndPoints, baseApiURL } from './config'

export default class Dashboard {
  apiServer: AxiosInstance
  baseUrl = `${baseApiURL}global-calendar/`

  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }

  async deleteEvent(id: number, EmailId: string) {
    const endUrlName = `${this.baseUrl + apiEndPoints.deleteEvent}?userEmail=${EmailId}`
    try {
      const response = await this.apiServer.delete(endUrlName, {
        data: {
          id: id
        }
      })

      return response
    } catch (err: any) {
      console.log('Error while Adding Webinar', err?.message)

      return err
    }
  }

  async getGlobalPeopleListForWebinar(searchVal: string) {
    const endUrlName = `${this.baseUrl + apiEndPoints.globalPeopleListForWebinar}?search=${searchVal}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error while Adding Webinar', err?.message)

      return err
    }
  }

  async getGlobalPeopleList(searchVal: string) {
    const endUrlName = `${this.baseUrl + apiEndPoints.globalPeopleList}?search=${searchVal}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error while Adding Webinar', err?.message)

      return err
    }
  }

  async getGlobalPeopleListById(id: string) {
    const endUrlName = `${this.baseUrl + apiEndPoints.globalPeopleListById}?id=${id}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error while Getting Global People List By Id', err?.message)

      return err
    }
  }

  async updateWebinarGlobalCalendar(email: string, payload: any, editingWebinarId: number) {
    const endUrlName = `${
      this.baseUrl + apiEndPoints.updateWebinarGlobalCalendar
    }?id=${editingWebinarId}&&userEmail=${email}`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error while Updating Webinar', err?.message)

      return err
    }
  }

  async getAllEvent(EmailId: string, startDate: string, endDate: string) {
    const endUrlName = `${
      this.baseUrl + apiEndPoints.getEvent
    }?userEmail=${EmailId}&startDateTime=${startDate}&endDateTime=${endDate}&eventTypes=all`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error while Adding Webinar', err?.message)

      return err
    }
  }

  async addEventGlobalCalendar(email: string, payload: any) {
    const endUrlName = `${this.baseUrl + apiEndPoints.addEventGlobalCalendar}?userEmail=${email}`
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error while Adding Event', err?.message)

      return err
    }
  }

  async addWebinarGlobalCalendar(email: string, payload: any) {
    const endUrlName = `${this.baseUrl + apiEndPoints.addWebinarGlobalCalendar}?userEmail=${email}`
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error while Adding Webinar', err?.message)

      return err
    }
  }

  async getAllWebinar(email: string, startDate: string, endDate: string) {
    const endUrlName = `${
      this.baseUrl + apiEndPoints.getAllWebinar
    }?userEmail=${email}&startDateTime=${startDate}&endDateTime=${endDate}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error while Getting Webinar', err?.message)

      return err
    }
  }

  async deleteWebinarGlobalCalendar(id: number, EmailId: string) {
    const endUrlName = `${this.baseUrl + apiEndPoints.deleteWebinarGlobalCalendar}?id=${id}&&userEmail=${EmailId}`
    try {
      const response = await this.apiServer.delete(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error while Deleting Webinar', err?.message)

      return err
    }
  }

  async updateEventGlobalCalendar(email: string, payload: any, editingEventId: number) {
    const endUrlName = `${
      this.baseUrl + apiEndPoints.updateEventGlobalCalendar
    }?id=${editingEventId}&&userEmail=${email}`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error while Adding Event', err?.message)

      return err
    }
  }
}
